import React, { useEffect } from 'react';
import SCORM from './SCORM'
import JIRA from './JIRA'
import config from '../../config.js'

const Tracking = props => {
    if(props.progress === undefined) return <></>; 

    const initializeProgressFromLMS = (bookmark) => {
        if(!bookmark) return;
        if(bookmark.suspendData) props.setProgress(bookmark.suspendData)
        if(bookmark.lessonLocation) props.setCurrentLocation(bookmark.lessonLocation)
    }

    const isModuleComplete = (moduleIndex = props.currentLocation.module) => {
        try{
            //return props.progress.modules[moduleIndex].lessons.filter(lesson => {
            return props.progress.modules[moduleIndex].lessons.filter((lesson, index) => {
                return lesson.chapters.filter(chapter => {
                    return chapter.segments.filter(segment => { 
                        if(index !== 0){                     
                            return segment.complete === false
                        }
                    }).length > 0; 
                }).length > 0
            }).length === 0
        }catch(e){
            console.log('isModuleComplete() error:', e, props.progress, props.currentLocation) 
            return false;
        }
        
    }

    return (
       <>
            {/* SCORM */}
            {   (!config.isAllenEnvironment && !config.isLocalHost) &&
                <SCORM
                    scoComplete={isModuleComplete()}
                    currentLocation={props.currentLocation}
                    progress={props.progress}
                    version={config.scorm.version}
                    onInit={initializeProgressFromLMS}
                    quit={props.quit}
                />
            }

            {/* xAPI - Tincan */}

            {/* JIRA */}
            {(config.isAllenEnvironment || config.isLocalHost) &&
            <JIRA
                jiraTag={config.jiraTag}
                currentLocation={props.currentLocation}
                contentData={props.contentData}
                generateLocationLink={props.generateLocationLink}
            />}

       </>
    )
}

export default Tracking